import { setTranslationsToStorage } from '../../../utils/cms/set-translations-to-storage';
import { translations } from '../cms.cache';

export const setTranslations = (translationsData: object) => {
  window?.localStorage.removeItem('pwa.translations');
  setTranslationsToStorage(translationsData);
  translations(translationsData);
};

export const useSetTranslations = () => ({
  setTranslations,
});
